import MicroModal from 'micromodal';
import topBar from './modules/top-bar';
import sharing from './modules/sharing';

// Enable flowbite library if you want to enable the following components.
//import 'flowbite';

//import './components/custom-toggle';
//import './components/user-avatar';
//import './components/user-menu';
//import './components/theme-switch';
//import userManagement from './modules/user-management';

MicroModal.init({
  disableScroll: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
});

topBar();
sharing();
//userManagement();
